import { ClaimEntity } from '../entities/entities.types';
import { AppState } from '../root.reducer';

export const getClaimById = (state: AppState, claimId?: string): ClaimEntity | undefined => {
  if (!state.entities.claim) return undefined;
  if (!claimId) return undefined;

  return state.entities.claim[claimId];
};
